import type { CompleteStylistFragment } from '@drycut/graphql';

import { Para, Stack } from '@drycut/ui-components';
import { getStylistInitials } from '@drycut/ui-format-utils';
import { ClockIcon, ScissorsIcon } from '@heroicons/react/20/solid';
import { twMerge } from 'tailwind-merge';

type Props = {
  stylist: CompleteStylistFragment;
};

export default function EmployeeAvatarWithState({ stylist }: Props): React.ReactElement {
  const onBreak = stylist.state === 'BREAK';
  const onService = stylist.state === 'WORKING';

  const defaultAvatarClasses =
    'relative flex items-center justify-center rounded-full w-20 h-20 bg-primary-600/70';
  const avatarClasses = twMerge(
    defaultAvatarClasses,
    onBreak ? 'bg-orange-400' : '',
    onService ? 'bg-zinc-800' : '',
  );

  return (
    <div className={avatarClasses}>
      {stylist.currentBreak && (
        <Para
          weight="bold"
          size="xs"
          className="absolute top-0 -right-5 rounded-full bg-rose-400 text-white border-2 border-white"
        >
          <Stack as="span" direction="row" gap={1} className="py-0.5 px-2">
            <ClockIcon className="w-3 h-3" />
            {stylist.currentBreak?.duration / 60}
          </Stack>
        </Para>
      )}

      {stylist.currentServiceExecution && onService && (
        <div className="absolute top-0 -right-3 rounded-full p-1 bg-zinc-800 text-white border-2 border-white">
          <ScissorsIcon className="w-4 h-4" />
        </div>
      )}

      <span className="antialiased text-4xl text-zinc-50 font-ramillas select-none">
        {getStylistInitials(stylist.name)}
      </span>
    </div>
  );
}
